<app-maintenance-mode-alert></app-maintenance-mode-alert>
<app-location-context-panel></app-location-context-panel>

<!-- Content -->
<div class="content">
    <mat-card>
        <mat-card-content>
            <div class="container">
                <h1>Event Logs</h1>

                <app-loading-indicator [loading]="loading"></app-loading-indicator>

                <div class="top-controls">
                    <!-- Filter -->
                    <mat-form-field>
                        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
                    </mat-form-field>
                </div>

                <!-- Table -->
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" aria-describedby="event-logs-table">
                    <!-- Event Date -->
                    <ng-container matColumnDef="dateString">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header id="dateString">Date</th>
                        <td mat-cell *matCellDef="let eventLog">
                            {{ eventLog?.dateString | date: 'dd-MM-yyyy hh:mm' }}
                        </td>
                    </ng-container>

                    <!-- Event Type -->
                    <ng-container matColumnDef="eventType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header id="eventType">Type</th>
                        <td mat-cell *matCellDef="let eventLog">{{ eventLog?.eventType }}</td>
                    </ng-container>

                    <!-- Event Message -->
                    <ng-container matColumnDef="eventMessage">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header id="eventMessage">Event Message</th>
                        <td mat-cell *matCellDef="let eventLog">{{ eventLog?.eventMessage }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="showDetail(row)"></tr>
                </table>

                <!-- No Data Message -->
                <div class="no-data" *ngIf="!loading && (dataSource.data.length === 0 || dataSource.filteredData.length === 0)">
                    <span>No data found</span>
                </div>

                <!-- Pager -->
                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
